import { render, staticRenderFns } from "./ChartCustomElements.vue?vue&type=template&id=bd8a2578&scoped=true&"
import script from "./ChartCustomElements.vue?vue&type=script&lang=js&"
export * from "./ChartCustomElements.vue?vue&type=script&lang=js&"
import style0 from "./ChartCustomElements.vue?vue&type=style&index=0&id=bd8a2578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8a2578",
  null
  
)

export default component.exports